import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const Section = Loader(
  lazy(
    () =>
      import(
        'src/content/admin-content/Content-Management/Content-Submenu/Sub-Menu/index'
      )
  )
);

const CreateContent = Loader(
  lazy(
    () =>
      import(
        'src/content/admin-content/Content-Management/AddOrEditContent/index'
      )
  )
);

const TreeView = Loader(
  lazy(
    () =>
      import(
        'src/content/admin-content/Content-Management/Content-Submenu/TreeView'
      )
  )
);

const contentRoutesAdmin = [
  {
    path: '',
    element: <Navigate to="content" replace />
  },
  {
    path: 'add-or-update-content',
    element: <CreateContent />
  },
  {
    path: 'content',
    element: <Section />
  },
  {
    path: 'tree-view',
    element: <TreeView />
  }
];

export default contentRoutesAdmin;
